export const DEPOSIT_STATUS_STYLE: Record<string, string> = {
    Approved: "bg-[#003525] text-[#26FFBD]",
    Rejected: "bg-[#280401] text-[#FF6355]",
    Pending: "bg-[#001F3A] text-[#8ECAFF]",
    Reverted: "bg-[#001F3A] text-[#8ECAFF]",
    Inprogress: "bg-[#001F3A] text-[#8ECAFF]",
};

export const WITHDRAW_STATUS_STYLE: Record<string, string> = {
    Approved: "bg-[#003525] text-[#26FFBD]",
    Rejected: "bg-[#280401] text-[#FF6355]",
    Pending: "bg-[#001F3A] text-[#8ECAFF]",
    Reverted: "bg-[#001F3A] text-[#8ECAFF]",
    Hold: "bg-[#001F3A] text-[#8ECAFF]",
    Verified: "bg-[#001F3A] text-[#8ECAFF]",
    Processing: "bg-[#001F3A] text-[#8ECAFF]",
    Inprogress: "bg-[#001F3A] text-[#8ECAFF]",
};

export const EXCHANGE_STATUS_STYLE: Record<string, string> = {
    Win: "bg-[#003525] text-[#26FFBD]",
    Lost: "bg-[#280401] text-[#FF6355]",
    Open: "bg-[#001F3A] text-[#8ECAFF]",
    Voided: "bg-[#001F3A] text-[#ECECFF]",
    Cancelled: "bg-[#001F3A] text-[#FF6355]",
    Commission: "bg-[#001F3A] text-[#E9DE7A]",
};

export const SPORTS_STATUS_STYLE: Record<string, string> = {
    win: "bg-[#003525] text-[#26FFBD]",
    lost: "bg-[#280401] text-[#FF6355]",
    open: "bg-[#001F3A] text-[#8ECAFF]",
    refund: "bg-[#001F3A] text-[#8ECAFF]",
    not_accepted: "bg-[#001F3A] text-[#8ECAFF]",
    half_win: "bg-[#001F3A] text-[#8ECAFF]",
    half_lost: "bg-[#001F3A] text-[#8ECAFF]",
    cashout: "bg-[#001F3A] text-[#8ECAFF]",
};

export const CASINO_STATUS_STYLE: Record<string, string> = {
    Win: "bg-[#003525] text-[#26FFBD]",
    Lost: "bg-[#280401] text-[#FF6355]",
    Open: "bg-[#001F3A] text-[#8ECAFF]",
    Refund: "bg-[#3A2E00] text-[#FFD166]",
};

export const ADJUSTMENTS_STATUS_STYLE: Record<string, string> = {
    Added: "bg-[#003525] text-[#26FFBD]",
    Subtracted: "bg-[#280401] text-[#FF6355]",
};